import React from "react";
import { BaseBtnProps } from "./types/BaseBtn.types";
import { Link, Text } from "@sitecore-jss/sitecore-jss-react";
import "./BaseBtn.scss";

const BaseBtn = (props: BaseBtnProps) => {
  const {
    text,
    url,
    action = () => {},
    isRed,
    isFullwidth,
    className,
    imageIcon,
    imageHoverIcon,
    icon,
    target = "self",
    id,
    sitecoreProps,
    minWidth,
    customAttributes,
  } = props;
  let myClass = isRed ? "BaseBtn BaseBtn--red" : "BaseBtn";
  myClass += " ga4-click-ui";
  if (className) {
    myClass += ` ${className}`;
  }
  if (isFullwidth) {
    myClass += " BaseBtn--fullwidth";
  }
  const ButtonContent = () => (
    <>
      {(props.fields?.iconCssClass?.value || icon) && (
        <span
          className={`icon ${props.fields?.iconCssClass?.value || icon} mr-10`}
        />
      )}

      {imageIcon?.value?.src && (
        <img
          className="BaseBtn__image_icon"
          src={imageIcon.value.src}
          alt={imageIcon.value.alt}
          height={imageIcon.value?.height}
          width={imageIcon.value?.width}
        />
      )}

      {imageHoverIcon?.value?.src && (
        <img
          className="BaseBtn__image_hover_icon"
          src={imageHoverIcon.value.src}
          alt={imageHoverIcon.value.alt}
          height={imageHoverIcon.value?.height}
          width={imageHoverIcon.value?.width}
        />
      )}

      <Text
        field={props.fields?.label || { value: text?.value }}
        tag={"h3"}
      ></Text>
    </>
  );

  return (
    <>
      {(props.fields?.link?.value?.href || url) && (
        <Link
          field={
            props.fields?.link || {
              value: {
                text: (
                  <>
                    {icon && <span className={`icon ${icon} mr-10`} />}
                    {text?.value}
                  </>
                ),
                target:
                  target === "blank"
                    ? "_blank"
                    : target !== "download"
                    ? "_self"
                    : "_self",
                href: url,
                id,
              },
              ...sitecoreProps,
            }
          }
          className={myClass}
          style={minWidth ? { minWidth: minWidth } : {}}
          onClick={action}
          rel="noopener noreferrer"
          download={target === "download"}
          data-engine-info={customAttributes}
        >
          <ButtonContent />
        </Link>
      )}
      {!(props.fields?.link?.value?.href || url) && (
        <div className={myClass} onClick={action}>
          <ButtonContent />
        </div>
      )}
    </>
  );
};

export default BaseBtn;
